import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Globe } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-4 pb-4 px-4 relative overflow-hidden" data-id="element-82">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-83">
        {/* Title on top */}
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-3 leading-tight text-white tracking-tight uppercase" data-id="element-84">
          Organiza tus clases de{' '}
          <span className="text-brand-accent neon-glow" data-id="element-85">Filosofía</span> sin
          empezar desde cero cada semana.
        </h1>

        {/* Image centered and clickable */}
        <div className="w-full max-w-[320px] md:max-w-md mx-auto my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} data-id="element-86">
          <div className="absolute inset-0 bg-brand-accent/20 blur-3xl rounded-full" data-id="element-87"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5fAw5A7WwFFYmexMgUHE6f/MOCKUPS_FILOSOFIA.png" alt="Kit Completo Filosofía Lista" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-88" />
        </div>

        {/* Subtitle below image */}
        <p className="text-sm md:text-lg mb-3 font-bold text-gray-200 max-w-2xl mx-auto leading-relaxed" data-id="element-89">
          Planificá todo tu año de clases de Filosofía, Ética y Ciudadanía en
          una tarde — sin leer textos densos ni perder fines de semana buscando
          material que nadie entiende.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-4 w-full" data-id="element-90">
          <div className="flex items-center bg-brand-card px-3 py-1.5 rounded-full border border-brand-accent/30 text-[10px] md:text-xs font-bold text-white" data-id="element-91">
            <FileText className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-92" />
            <span data-id="element-93">100% PDF</span>
          </div>
          <div className="flex items-center bg-brand-card px-3 py-1.5 rounded-full border border-brand-accent/30 text-[10px] md:text-xs font-bold text-white" data-id="element-94">
            <Zap className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-95" />
            <span data-id="element-96">Acceso inmediato</span>
          </div>
          <div className="flex items-center bg-brand-card px-3 py-1.5 rounded-full border border-brand-accent/30 text-[10px] md:text-xs font-bold text-white" data-id="element-97">
            <Globe className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-98" />
            <span data-id="element-99">Toda Latinoamérica</span>
          </div>
        </div>

        <div className="w-full max-w-sm mx-auto mb-3" data-id="element-100">
          <Button className="text-base md:text-xl py-3 md:py-4 shadow-[0_0_30px_rgba(0,255,136,0.4)]" data-id="element-101">
            📜 → QUIERO MI KIT DE FILOSOFÍA AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-400 font-bold" data-id="element-102">
          <div className="flex items-center" data-id="element-103">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-104" />
            <span data-id="element-105">Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center" data-id="element-106">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-107" />
            <span data-id="element-108">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-109">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-110" />
            <span data-id="element-111">Pagás en la moneda de tu país</span>
          </div>
        </div>
      </div>
    </section>;
}